
const isCombinedMatch = (matchId) =>
    (matchId >= 9100000000 && matchId < 9199999999);

export default isCombinedMatch;
